// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2yLls","question":"Question_question__3kMyI","description":"Question_description__2JF4K"};